import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TModuleProgress, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching module progress - non-hook version
 */
export const getModuleProgressQueryKey = (spaceId: string) => [ENTITY, 'module-progress', spaceId];

/**
 * Query key for fetching module progress
 */
export const useGetModuleProgressQueryKey = (spaceId: string) => getModuleProgressQueryKey(spaceId);

/**
 * Hook to fetch module progress for the current user
 * Returns totalLessons, completedLessons, and progressPercent
 *
 * @param spaceId - Space ID (UUID) - should be a content sub-space (module)
 */
export const useGetModuleProgress = (spaceId: string) => {
  return useQuery<TModuleProgress, TError>({
    queryKey: useGetModuleProgressQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TModuleProgress>(`/community-hub/spaces/${spaceId}/progress`);
      return res.data;
    },
    enabled: !!spaceId,
    staleTime: 60 * 1000, // 1 minute
  });
};
